import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const ColumnDisplay = styled.div`
    gap: 1rem;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const TicketContainer = styled(ColumnDisplay)`
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}

    &,
    & * {
        line-height: 1.5;
        ${FONT_PROPERTIES}
    }
`;

export const BoldedItem = styled.strong`
    font-weight: bold;
    text-transform: capitalize;
    text-align: ${({ $textAlign = 'left' }) => $textAlign};
`;

export const TicketSaleDataContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
`;

export const StyledTotal = styled(BoldedItem)`
    ${FONT_PROPERTIES}
`;

export const DateSubDetails = styled.div`
    font-size: 0.85em;
`;
